import { render, staticRenderFns } from "./AddFollowUpsDialog.vue?vue&type=template&id=780a328b&scoped=true"
import script from "./AddFollowUpsDialog.vue?vue&type=script&lang=js"
export * from "./AddFollowUpsDialog.vue?vue&type=script&lang=js"
import style0 from "./AddFollowUpsDialog.vue?vue&type=style&index=0&id=780a328b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a328b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780a328b')) {
      api.createRecord('780a328b', component.options)
    } else {
      api.reload('780a328b', component.options)
    }
    module.hot.accept("./AddFollowUpsDialog.vue?vue&type=template&id=780a328b&scoped=true", function () {
      api.rerender('780a328b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/AddFollowUpsDialog.vue"
export default component.exports